const API_BASE_URL =
  process.env.REACT_APP_API_URL || "";

export const getContents = async (type) => {
  const response = await fetch(`${API_BASE_URL}/api/content?type=${type}`);

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت محتواها");
  }

  return data.contents || [];
};

export const getContentBySlug = async (slug) => {
  const response = await fetch(`${API_BASE_URL}/api/content/${slug}`);

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت جزئیات محتوا");
  }

  return data.content;
};